import IconArrowLeft from '../icon/IconArrowLeft';
import React from 'react';
import If from '../utils/If';
import cn from 'classnames';

type Props = {
  back?: {
    url: string;
    label: string;
  },
  forward?: {
    url: string;
    label: string;
  },
}

export default function BackForward({back, forward}: Props) {
  return (
    <div className="grid grid-cols-2 mt-4">
      <If condition={!!back}>
        <a href={back?.url} className={cn('pt-5 pb-3 text-blue block', {'col-span-2': !forward})}>
          <IconArrowLeft className="mb-0.5"/> {back?.label}</a>
      </If>
      <If condition={!!forward}>
        <a href={forward?.url} className={cn('pt-5 pb-3 text-blue block justify-self-end', {'col-span-2': !back})}>
          {forward?.label} <IconArrowLeft className="transform rotate-180 -mb-0.5"/>
        </a>
      </If>
    </div>
  );
}
